/************ CONSTANTS ***********/
export const CURRENCY = 'R';
